export default {
  dataIterator: {
    rowsPerPageText: 'Registros por página:',
    rowsPerPageAll: 'Todos',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'No se encontraron coincidencias',
    nextPage: 'Siguiente página',
    prevPage: 'Página anterior'
  },
  dataTable: {
    rowsPerPageText: 'Filas por página:'
  },
  noDataText: 'No hay coincidencias'
};



// WEBPACK FOOTER //
// ./src/common/lang/es/vuetify.js